import { defineComponent as _defineComponent } from 'vue'
import { type Project, WpProject } from "@/stores/api";


export default /*#__PURE__*/_defineComponent({
  props: {
    project: { type: null, required: true },
    size: { type: String, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as { project: Project | WpProject; size: "lg" | "sm" }



const getColor = (color: "bg-beige-100" | "bg-beige-200" | "bg-beige-300" | "bg-brown-100" | "bg-brown-200" | "bg-gold") => {
    let text = "text-white";

    if (["bg-beige-100", "bg-beige-200", "bg-beige-300"].includes(color)) {
        text = "text-brown-200";
    }
    return `${color} ${text}`;
};

let title = "";
//@ts-ignore
if (props.project.title) {
    //@ts-ignore
    title = props.project.title.rendered;
    //@ts-ignore
} else if (props.project.post_title) {
    //@ts-ignore
    title = props.project.post_title;
}

const __returned__ = { props, getColor, title }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})